var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"a-iosPrompt",on:{"click":_vm.toggle}},[_vm._t("default"),_c('transition',{attrs:{"name":"fade-fast"}},[(_vm.show)?_c('div',{staticClass:"a-iosPrompt__message",domProps:{"innerHTML":_vm._s(_vm.message)}}):_vm._e()])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }